import React from "react"
import { Table, FormControl, Button } from "react-bootstrap"
import FontAwesome from "react-fontawesome"
import apiServerApi from "../../redux/sagas/apiServerApi"
import CloseableProcessesStatus from "../fragments/CloseableProcessesStatus"
import { blockingFetchService } from "../../lib/blockingFetch"
import moment from "moment"
import { ACCEPTED_STATUS, ALL_STATUS, CustomerType, getBusinessName,
  getCustomerFullName, LoanStatus, REJECTED_STATUS } from "../../lib/utils"
import AlertModal from "../fragments/AlertModal"
import MomoCard from "./MomoCard"
import CustomBreadCrumb from "../fragments/CustomBreadCrumb"

const CVS_MOMO = {
  key: 'MTN_MOBILE_MONEY',
  value: 'MTN Mobile Money',
},

CSV_STATUS = {
  SUCCESS: 'SUCCESS', 
  NONE: 'NONE',
},

CSV_TYPE = {
  PAYEMENT: 'PAYEMENT', 
  CASH_IN: 'CASH_IN',
  NONE: 'NONE',
},

FilterStatus = [ALL_STATUS, REJECTED_STATUS, ACCEPTED_STATUS],

CVS_TYPES = [CVS_MOMO],

CENTER_CENTER = 'v-center align-center'

class BatchRepayment extends React.Component {

  state = {
    csvType: CVS_TYPES[0].key,
    csvMomo: [],
    originalCsvMomo: [],
    selectedLoans: [],
    filterStatus: FilterStatus[0].key,

    running: false,
    success: false,
    error: null,
    alreadyLoaded: false,
    closeStatuses: false,
    showRemove: false,
    showRemoveId: 0,
    showDetails: false,
    rowDetailKey: 0,
  }

  submitFile = ({ target }) => {

    if(target.files && target.files.length > 0) {

      this.setState({
        running: true,
        error: null,
        success: false,
        closeStatuses: false,
      })

      const file = target.files[0]
      target.value = null
      target.files = null

      if(this.state.csvType !== CVS_MOMO.key) {
        this.setState({ error: 'Incorrect csv type!' })
        return
      }

      blockingFetchService(
        accessToken => apiServerApi.parseCsvMomo(accessToken, file), 
        response => this.manageParseResponse(response),
        error => this.setState({ error: error.text }),
        _ => this.setState({ running: false })
      )
    }
  }

  getFilteredLoans = loans => {
    const filteredLoans = !loans
    ? []
    : loans
      .filter(item => item.status === LoanStatus.COMPLETED)
      .map(item => ({
        id: item.id,
        name: item.bundle.name + ' (' + item.bundle.shortName + ')',
        currency: item.bundle.currencyCode,
        createdOn: moment(item.createdOn).format('YYYY-MM-DD'),
        amount: item.amount,
        clientName: item.business ? getBusinessName(item.business) : getCustomerFullName(item.customer),
        clientPhoneNumber: item.clientPhoneNumber,
        clientId: item.clientId,
        isBusiness: item.customerType === CustomerType.BUSINESS,
      }))

    return filteredLoans
  }

  getCsvRowStatus = (row, isDuplicated) => {

    const { exists, status, type, amount, loans } = row
    let lineStatus = ACCEPTED_STATUS.key

    if(isDuplicated || exists || type !== CSV_TYPE.PAYEMENT || status !== CSV_STATUS.SUCCESS
      || isNaN(amount) || Number(amount) <= 0 || !loans.length) {
      lineStatus = REJECTED_STATUS.key
    }
    return lineStatus
  }

  manageParseResponse = list => {

    const selectedLoans = []
    for(let i = 0; i < list.length; i++) {
      const item = list[i]
      item.isDuplicated = this.isDuplicatedMomoId(i, item.id, list)
      item.rowState = this.getCsvRowStatus(item, item.isDuplicated)
      item.loans = this.getFilteredLoans(item.loans)
      item.key = i
      const size = item.loans.length

      if(size) {
        const loan = item.loans[size - 1],
        selected = {
          momoId: item.id,
          key: i,
          loanId: loan.id,
          currency: loan.currency,
        }
        selectedLoans.push(selected)
      }
    }

    this.setState({
      csvMomo: list,
      originalCsvMomo: list,
      selectedLoans,
      alreadyLoaded: true,
      filterStatus: FilterStatus[0].key
    })
  }

  collectData = () => {

    const { originalCsvMomo } = this.state,
    data = []
    for(let i = 0; i < originalCsvMomo.length; i++) {

      const { id, date, fromName, amount, fee, rowState } = originalCsvMomo[i]
      if(rowState === REJECTED_STATUS.key) {
        continue
      }

      const repayment = {
        transactionDate: moment().format('YYYY-MM-DD'),
        transactionAmount: amount,
        paymentType: 'CASH',
        note: '',
        externalId: id,
        externalDate: date,
        fromName: fromName,
        fee: fee,
        loanId: this.getSelectedLoanIdByMomoId(id)
      }

      data.push(repayment)
    }

    return data
  }

  saveBatchRepayment = () => {

    const data = this.collectData()
    this.setState({
      running: true,
      success: false,
      error: null,
      closeStatuses: false,
    })

    blockingFetchService(
      accessToken => apiServerApi.batchRepayment(accessToken, data),
      _ => this.setState({ success: true, csvMomo: [], originalCsvMomo: [], selectedLoans: [] }),
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  isDuplicatedMomoId = (index, momoId, list) => {

    for (let i = 0; i < index; i++) {
      const item = list[i]
      if(item.id === momoId) {
        return true
      }
    }
    return false
  }

  getSelectedLoan = momoId => this.state.selectedLoans.find(item => item.momoId === momoId)

  getSelectedLoanIdByMomoId = momoId => {
    const item = this.getSelectedLoan(momoId)
    return item ? item.loanId : ''
  }

  getSelectedCurrencyByMomoId = momoId => {
    const item = this.getSelectedLoan(momoId)
    return item ? item.currency : ''
  }

  currentLoanChanged = (momoId, loanId, loans) => {

    let { selectedLoans } = this.state

    selectedLoans = selectedLoans.map(item => {
      if(item.momoId === momoId) {
        item.loanId = loanId
        const loan = loans.find(item => item.id === loanId)
        if(loan) {
          item.currency = loan.currency
        }
      }
      return item
    })

    this.setState({ selectedLoans })
  }

  csvTypeChanged = csvType => this.setState({ csvType })

  getFilteredItems = (filterStatus, list) => {

    switch(filterStatus) {
      case REJECTED_STATUS.key: {
        return list.filter(item => item.rowState === REJECTED_STATUS.key)
      }
      case ACCEPTED_STATUS.key: {
        return list.filter(item => item.rowState === ACCEPTED_STATUS.key)
      }
      default: {
        return list
      }
    }
  }

  filterStatusChanged = filterStatus => {

    const { originalCsvMomo } = this.state,
    csvMomo = this.getFilteredItems(filterStatus, originalCsvMomo)
    this.setState({ filterStatus, csvMomo })
  }

  removeEntry = key => {

    let { originalCsvMomo, filterStatus } = this.state
    originalCsvMomo = originalCsvMomo
      .filter(item => item.key !== key)
      .map((item, index, arr) => {
        item.isDuplicated = this.isDuplicatedMomoId(index, item, arr)
        item.rowState = this.getCsvRowStatus(item, item.isDuplicated)
        return item
      })

    const csvMomo = this.getFilteredItems(filterStatus, originalCsvMomo)
    this.setState({ originalCsvMomo, csvMomo })
  }

  seeDetails = key => this.setState({ rowDetailKey: key, showDetails: true })

  renderButtonTop = csvType => {

    return (
      <div className="flex-row mb-10 green hover-green">

        <div>
          <FormControl componentClass="select" placeholder="select"
            value={ csvType }
            onChange={e => this.csvTypeChanged(e.target.value) }>
            { CVS_TYPES.map((item, index) =>
              <option key={ index } value={ item.key }>{ item.value }</option>
            )}
          </FormControl>
        </div>

        <div className="align-center">
          <input
            type="file"
            id="csv-file"
            className="hidden-input-file"
            accept=".csv"
            onChange={ this.submitFile }
          />
          <label htmlFor="csv-file" className="cursor-pointer">
            <FontAwesome name='cloud-upload' size='2x'/><br/>
            Upload csv file
          </label>
        </div>
      </div>
    )
  }

  renderNotif = alreadyLoaded => {

    if(alreadyLoaded) return null
    return (
      <tr>
        <td colSpan={9} className="pv-40 align-center green hover-green">
          <label htmlFor="csv-file" className="cursor-pointer">
            <FontAwesome name='cloud-upload' size='5x'/><br/>
            Click here to upload csv file
          </label>
        </td>
      </tr>
    )
  }

  renderStatuses = (error, running, success, closeStatuses) =>
    <CloseableProcessesStatus
      error={ error }
      running={ running }
      success={ success }
      close={ closeStatuses }
      handleClose={() => this.setState({ closeStatuses: true }) }
    />

  renderTh = text => <th className={ CENTER_CENTER }>{ text }</th>

  renderThActions = () => <th className={ `${ CENTER_CENTER } w-50` }></th>

  renderThOperations = filterStatus => 
    <th className='w-100'>
      <FormControl componentClass="select" placeholder="select"
        value={ filterStatus }
        onChange={e => this.filterStatusChanged(e.target.value) }
        className='gray align-center p-1'>
        { FilterStatus.map((item, index) =>
          <option key={ index } value={ item.key }>{ item.value }</option>
        )}
      </FormControl>
    </th>

  renderDoubleLineTh = (text1, text2) =>
    <th className={ CENTER_CENTER }>
      <span>{ text1 }</span><br/>
      <span className='gray'>{ text2 }</span>
    </th>

  renderTd = (key, content, className) =>
    <td className={ `v-center ${ className }` } onClick={() => this.seeDetails(key)}>
      { content }
    </td>

  renderDoubleLineTd = (key, text1, text2, className) =>
    this.renderTd(
      key,
      <span><span>{ text1 }</span><br/><span className='gray'>{ text2 }</span></span>, 
      className
    )

  renderLoans = (momoId, loans) => 
    <td className={ CENTER_CENTER }>
    { !loans.length
      ? '-'
      : <FormControl componentClass="select" placeholder="select" className="max-width-200"
        value={ this.getSelectedLoanIdByMomoId(momoId) }
        onChange={e => this.currentLoanChanged(momoId, e.target.value, loans)}>
        { loans.map((item, index) =>
          <option key={ index } value={ item.id }>{ item.name } - { item.createdOn }</option>
        )}
      </FormControl>
    }
    </td>

  renderActions = (key, showRemove, showRemoveId) => 
    <td className={ `${ CENTER_CENTER } gray`}>
      <span className={ (showRemove && showRemoveId === key) ? 'display-block' : 'm_hide' }
        title="Remove this entry!"
        onClick={e => {
          e.stopPropagation()
          this.removeEntry(key)
        }}>
        <FontAwesome name='close' size="lg" />
      </span>
    </td>

  getIllustration = item => {

    const { id, exists, status, type, amount, currency, loans, isDuplicated, info } = item,
    selectedCurrency = this.getSelectedCurrencyByMomoId(id),

    failed = <span className="red"><FontAwesome name='minus-circle' /></span>,
    success = <span className="green"><FontAwesome name='check-circle' /></span>,
    warning = <span className="yellow"><FontAwesome name='warning' /></span>
    let icon = null,
    title = ''

    if(isDuplicated) {
      icon = failed
      title = `Rejected. ID ${ id } is duplicated!`
    }
    else if(exists) {
      icon = failed
      title = `Rejected. Payment ID ${ id } is already saved!`
    }
    else if(type !== CSV_TYPE.PAYEMENT) {
      icon = failed
      title = 'Rejected. No Payment!'
    }
    else if(status !== CSV_STATUS.SUCCESS) {
      icon = failed
      title = 'Rejected. Operation not successful!'
    }
    else if(isNaN(amount) || Number(amount) <= 0) {
      icon = failed
      title = 'Rejected. Incorrect Amount!'
    }
    else if(!loans.length) {
      icon = failed
      title = 'Rejected. Loan not found!'
    }
    else if(selectedCurrency !== currency) {
      icon = warning
      title = `Warning. The loan currency is ${ selectedCurrency }!`
    }
    else {
      icon = success
      title = info ? info : 'Accepted!'
    }

    return { icon, title }
  }

  renderCsvData = (csvMomo, showRemove, showRemoveId) => {

    return csvMomo.map((item, index) => {

      const { id, date, fromName, from, status, type, amount, fee, currency,
        loans, key, isDuplicated } = item,
      itemID = <span className={ isDuplicated ? 'duplicate-line' : '' }>{ id }</span>,
      illustration = this.getIllustration(item)

      return <tr key={ index } title={ illustration.title }
        className='cursor-pointer'
        onMouseEnter={() => this.setState({ showRemove: true, showRemoveId: key })}
        onMouseLeave={() => this.setState({ showRemove: false, showRemoveId: 0 })}>
        { this.renderTd(key, itemID, 'align-center') }
        { this.renderTd(key, moment(date).format('lll'), '') }
        { this.renderDoubleLineTd(key, fromName, from) }
        { this.renderDoubleLineTd(key, status, type, 'small align-center') }
        { this.renderDoubleLineTd(key, amount, fee, 'align-center') }
        { this.renderTd(key, currency, 'small align-center') }
        { this.renderLoans(id, loans) }
        { this.renderTd(key, illustration.icon, CENTER_CENTER) }
        { this.renderActions(key, showRemove, showRemoveId) }
      </tr>
    })
  }

  renderButtonSubmit = (originalCsvMomo, running) => {

    const nb = originalCsvMomo.length
    if(!nb) return null

    const accepted = originalCsvMomo.filter(item => item.rowState === ACCEPTED_STATUS.key).length
    return (
      <tr>
        <td colSpan={9} className="pv-40 align-right">
          <strong title={`Total ${accepted}/${nb} accepted!`} className="gray">
            Total {accepted}/{nb}
          </strong> &nbsp;
          <Button bsStyle="success" bsSize="large" onClick={ this.saveBatchRepayment }
            disabled={ running || accepted === 0 }>
            <FontAwesome name='save' /> Save
          </Button>
        </td>
      </tr>
    )
  }

  renderMomoDetails = key => {

    const { originalCsvMomo } = this.state,
    item = originalCsvMomo.find(item => item.key === key)
    return item ? <MomoCard item={ item } illustration={ this.getIllustration(item) } /> : null
  }

  render() {

    const { success, running, error, alreadyLoaded, closeStatuses, showDetails,
      csvMomo, csvType, filterStatus, originalCsvMomo, showRemove, showRemoveId, rowDetailKey } = this.state,

    dataBreadCrumbs = [{ url: '/loans', title: 'Loans' }]

    return (
      <div className="mb-20">

        <CustomBreadCrumb activeText='Batch Repayment' data={ dataBreadCrumbs } />

        { this.renderButtonTop(csvType) }

        { this.renderStatuses(error, running, success, closeStatuses) }

        <Table responsive striped bordered condensed hover>
          <thead>
            <tr>
              { this.renderTh('ID') }
              { this.renderTh('Date') }
              { this.renderDoubleLineTh('Name', 'Phone Number') }
              { this.renderDoubleLineTh('Status', 'Type') }
              { this.renderDoubleLineTh('Amount', 'Fee') }
              { this.renderTh('Currency') }
              { this.renderTh('Loans') }
              { this.renderThOperations(filterStatus) }
              { this.renderThActions() }
            </tr>
          </thead>

          <tbody>

            { this.renderNotif(alreadyLoaded) }

            { this.renderCsvData(csvMomo, showRemove, showRemoveId) }

            { this.renderButtonSubmit(originalCsvMomo, running) }
          </tbody>
        </Table>

        { showDetails &&
        <AlertModal
          title={ 'Entry details' }
          close={() => this.setState({ showDetails: false })}
          show={ showDetails }
          body={ this.renderMomoDetails(rowDetailKey) }
        />
        }
      </div>
    )
  }
}

export default BatchRepayment



// WEBPACK FOOTER //
// ./src/components/Loans/BatchRepayment.js